import { Item } from './item';

export type ItemProps<T> = {
  id: T;
  primaryText: string;
  secondaryText?: string;
  errorText?: string;
};

export type ItemListProps<T> = {
  items: ItemProps<T>[];
  onRemove?: (id: T) => void;
  onEdit?: (id: T) => void;
};

export const ItemList = <T,>({ items, onRemove, onEdit }: ItemListProps<T>) => {
  if (!items.length) {
    return null;
  }

  return (
    <ul className="mb-3 flex flex-col gap-3">
      {items.map((item) => (
        <li key={String(item.id)}>
          <Item
            id={item.id}
            primaryText={item.primaryText}
            secondaryText={item.secondaryText}
            errorText={item.errorText}
            onEdit={onEdit}
            onRemove={onRemove}
          />
        </li>
      ))}
    </ul>
  );
};
